import t,{keyframes as r}from"styled-components";const o=r`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`,e=t.div.withConfig({displayName:"Loader",componentId:"VDS__sc-susmjq-0"})`
  animation: ${o} 1s linear infinite;
  background: transparent;
  border-bottom: 4px solid white;
  border-left: 4px solid transparent;
  border-radius: 50%;
  border-right: 4px solid white;
  border-top: 4px solid white;
  height: 24px;
  transform: translateZ(0);
  width: 24px;
`;export{e as default};
